import * as yup from 'yup';
import {
  alphabetRegix,
  alphaNumericRegix,
  alphaNumericSpecialCharacterRegix,
  numericDashRegix,
  numericRegix,
  phoneRegex,
} from '../utils/functions';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const individual_contact_info_validation_schema = yup.object().shape({
  mobileNumber: yup
    .string()
    .required('mobile_no_is_required')
    .test(
      'is-valid-phone',
      'invalid_phone_no',
      (value) => {
        if (!value) return false;
        return isValidPhoneNumber(value);
      }
    ),

  phoneNumber: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'valid-phone',
      'invalid_phone_no',
      function (value) {
        if (!value || value.trim() === '') {
          return true; // ✅ Empty allowed
        }
        return isValidPhoneNumber(value);
      }
    ),

  additionalPhoneNumber: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'valid-phone',
      'invalid_phone_no',
      function (value) {
        if (!value || value.trim() === '') {
          return true; // ✅ Empty allowed
        }
        return isValidPhoneNumber(value);
      }
    ),

  emailAddress: yup
    .string()
    .email('invalid_email')
    .required('email_is_required'),

  // confirmEmailAddress: yup
  //   .string()
  //   .email('invalid_email')
  //   .required('email_is_required'),

  preferenceForContactId: yup
    .array()
    .min(1, 'preferred_correspondence_is_required')
    .required('preferred_correspondence_is_required'),

  ksaNationalCountryId: yup
    .object()
    .required('country_is_required'),

  ksaNationalAddress: yup
    .string()
    .required('address_is_required')
    .matches(alphaNumericRegix, 'must_be_alphanumeric'),

  buildingNumber: yup
    .string()
    .max(50, 'building_no_must_not_exceed')
    .matches(numericDashRegix, 'invalid_building_no')
    .required('building_number_is_required'),

  district: yup
    .string()
    .max(50, 'district_must_not_exceed')
    .required('district_is_required')
    .matches(alphaNumericSpecialCharacterRegix, 'must_be_alphanumeric'),

  streetName: yup
    .string()
    .max(50, 'street_name_must_not_exceed')
    .matches(alphaNumericRegix, 'must_be_alphanumeric')
    .required('street_name_is_required'),

  unitNumber: yup
    .string()
    .max(50, 'unit_no_must_not_exceed')
    // .required('unit_number_is_required')
    .matches(numericRegix, 'must_be_numeric'),

  additionalNumber: yup
    .string()
    .max(50, 'additional_no_must_not_exceed')
    .required('addition_no_is_required')
    .matches(numericRegix, 'must_be_numeric'),

  postalCode: yup
    .string()
    // .max(11, 'postalcode_must_not_exceed')
    .required('postalcode_is_required')
    .matches(numericDashRegix, 'invalid_postal_code'),

  city: yup
    .string()
    .matches(alphabetRegix, 'invalid_city')
    .max(50, 'city_must_not_exceed')
    .required('city_is_required'),

  // province: yup
  //   .string()
  //   .required('province_is_required'),

});
